// export const API_URL = 'https://fjmotorsapi.azurewebsites.net/graphql';
// export const API_URL = 'http://84.8.141.242:4000/graphql';
// export const API_URL = 'https://fjmotorapi.duckdns.org:4000/graphql';
export const API_URL = 'https://fjmotorapiv2.duckdns.org:4000/graphql';
